<div>

  <tabset #staticTabs>
    <tab heading="General" #tabA="tab">
      @if (tabA.active) {
        <app-generalForm></app-generalForm>
      }
    </tab>
    <tab heading="{{ 'ContactTabs.SpecificProperty' | translate }}" #tabB="tab">
      @if (tabB.active) {
        <app-specificForm></app-specificForm>
      }
    </tab>
    <tab heading="{{ 'ContactTabs.DisasterRelief' | translate }}" #tabC="tab">
      @if (tabC.active) {
        <app-ads820></app-ads820>
      }
    </tab>
    <tab heading="{{ 'ContactTabs.Business' | translate }}" #tabD="tab">
      @if (tabD.active) {
        <app-businessForm></app-businessForm>
      }
    </tab>
    <tab heading="{{ 'ContactTabs.Prop19' | translate }}" #tabE="tab">
      @if (tabE.active) {
        <app-exclusionsForm></app-exclusionsForm>
      }
    </tab>
    <tab heading="{{ 'ContactTabs.TaxSavings' | translate }}" #tabF="tab">
      @if (tabF.active) {
        <app-taxSavingsForm></app-taxSavingsForm>
      }
    </tab>
    <tab heading="{{ 'ContactTabs.WebsiteSupport' | translate }}" #tabG="tab">
      @if (tabG.active) {
        <app-websiteSupport></app-websiteSupport>
      }
    </tab>
  </tabset>
</div>

